import React from 'react';
import Modal from 'react-modal';
import CreateEditSurvey from "../components/job/survey/CreateEditSurvey";

const CreateEditJobSurveyModal = (props) => {
    const {
        jobId       = null,
        surveyId    = null,
        show        = false,
        parentId    = "",
        disabled    = false,
        onCancel    = () => {},
        onComplete  = (survey) => {},
        onDelete    = (survey) => {},
        id          = "create-edit-job-survey-modal",
    } = props;

    const handleCancel = () => {
        onCancel();
    }

    const handleComplete = (survey) => {
        onComplete(survey);
    }

    const handleDelete = (survey) => {
        onDelete(survey);
    }

    return (
        <Modal
            ariaHideApp={false}
            isOpen={show}
            parentSelector={() => document.getElementById(parentId)}
            onRequestClose={() => handleCancel()}
            contentLabel={!!surveyId ? "Edit Survey Job" : "Create Survey Job"}
            className={'ReactModal__Content react-modal-outer modal-dialog admin-modal wide-modal allow-overflow'}
            style={{
                overlay: {
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    overflow: 'hidden',
                    outline: 'none',
                },
                content: {
                    width: "100%",
                    height: "100%",
                    padding: 0,
                    border: 0,
                    outline: 'none',
                },
            }}
        >
            <div className="p-4 modal-content" id={id}>
                <div className="modal-header border-0 m-0 p-0 pb-4">
                    <h4 className="modal-title text-eh-navy">{!!surveyId ? "Edit Survey Job" : "Create Survey Job"}</h4>
                    <button
                        type="button" className="close"
                        data-dismiss="modal" aria-label="Close"
                        onClick={() => handleCancel()}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body m-0 mb-3 p-0">
                    <CreateEditSurvey
                        jobId={jobId}
                        surveyId={surveyId}
                        onCancel={() => handleCancel()}
                        onComplete={(survey) => handleComplete(survey)}
                        onDelete={(survey) => handleDelete(survey)}
                    />
                </div>
            </div>
        </Modal>
    );
}

export default CreateEditJobSurveyModal;
